/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable prettier/prettier */
/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
// import error, { errorProps } from 'aurora-utils/error';
import { Box, withStyles } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import {
  formatCurrencyWithoutCurrency,
  keyEmptyCheck,
} from 'aurora-utils/utils';
import {
  CancelApplicationModal,
  ADGMBreadcrumbs,
  ADGMImage,
} from 'aurora-components';
import Container from '@material-ui/core/Container';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import classNames from 'classnames';
import styles from './styles';

function Payment(props) {
  const {
    classes,
    children,
    breadCrumbs,
    applicationId,
    balance,
    fees,
    paymentHanlder,
    submitApplicationCancel,
    walletFailure,
    isSale,
    isLease,
  } = props;
  const lowBalance = balance > fees?.totalAmmount;
  const [walletActive, setWalletActive] = useState(false);
  const [cardActive, setCardActive] = useState(true);
  const [
    isModalOpenApplicationReject,
    setModalOpenApplicationReject,
  ] = useState(false);
  const disableWalletOption =
    lowBalance || walletFailure?.statusCode === '100033';

  const toggleModalApplicationReject = () => {
    setModalOpenApplicationReject(!isModalOpenApplicationReject);
  };
  const payNowHanlder = () => {
    if (walletActive) {
      paymentHanlder('WALLET');
    } else {
      paymentHanlder('CARD');
    }
  };

  const creditCardHandler = () => {
    setCardActive(true);
    setWalletActive(false);
  };
  const walletHandler = () => {
    setWalletActive(true);
    setCardActive(false);
  };

  const DARI_SERVICE_FEE = useMemo(() => {
    return fees?.paymentGeneralDetailList?.filter(
      (fee) => fee.paymentType === 'DARI_SERVICE_FEE'
    )[0]?.amount;
  }, [fees]);
  return (
    <div className={classes.main}>
      <Container className={classes.container}>
        <Hidden mdDown>
          <div className={classes.breadcrumbsHolder}>
            <ADGMBreadcrumbs paths={breadCrumbs} />
            {applicationId && (
              <div className={classes.appId}>
                <Typography
                  variant='p'
                  component='h2'
                  className={classes.Title}
                >
                  <FormattedMessage {...messages.reference_ID} /> :{' '}
                  {applicationId}
                </Typography>
              </div>
            )}
          </div>
        </Hidden>
        <Hidden mdUp>
          <div className={classes.mobileTitlehead}>
            <div>
              <Link href='/app/applications'>
                <ADGMImage name='croseblackonmobile.svg' alt='croseimg' />{' '}
                <FormattedMessage {...messages.payment_summary} />
              </Link>
            </div>
            <div className={classes.trashIcon}>
              <ADGMImage
                name='cancel_payment.svg'
                alt='trash'
                onClick={toggleModalApplicationReject}
                aria-hidden
              />
            </div>
          </div>
        </Hidden>

        {fees && (
          <Grid container spacing={3} className={classes.gridContainer}>
            <Grid item xs={12} md={8}>
              {children}
              <Hidden smUp>
                <Paper variant='outlined' className={classes.paperCardFrame}>
                  <div className={classes.titleHead}>
                    <Typography
                      variant='h6'
                      component='h2'
                      className={classes.Title}
                    >
                      <FormattedMessage {...messages.pay_with} />
                    </Typography>
                  </div>
                  <div className={classes.innerCardGrid}>
                    {lowBalance ? (
                      <div className={classes.adgmwalletDetail}>
                        <div className={classes.warningmassage}>
                          <ADGMImage
                            name='Information.svg'
                            alt='InformationIcon'
                          />
                          <Typography variant='body1'>
                            <FormattedMessage
                              {...messages.wallet_empty_message}
                            />
                          </Typography>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}

                    <div className={classes.debitcardDetail}>
                      <div className={classes.radioactiveHolder}>
                        <FormControl
                          component='fieldset'
                          className={classes.fieldsetradio}
                        >
                          <RadioGroup className={classes.usercheckedradio}>
                            <Radio
                              value='card'
                              name='radio-button-demo'
                              inputProps={{ 'aria-label': 'A' }}
                              id='userRadioA'
                              checked={cardActive}
                              onClick={creditCardHandler}
                            />
                            <label
                              htmlFor='userRadioA'
                              className={classes.radioHelperText}
                            >
                              <span>
                                <FormattedMessage
                                  {...messages.debit_credit_card}
                                />
                              </span>
                            </label>
                          </RadioGroup>
                          {!disableWalletOption && (
                            <RadioGroup className={classes.usercheckedradio}>
                              <Radio
                                value='wallet'
                                name='radio-button-demo'
                                inputProps={{ 'aria-label': 'b' }}
                                id='userRadiob'
                                checked={walletActive}
                                onClick={walletHandler}
                                disabled={disableWalletOption}
                              />
                              <label
                                htmlFor='userRadiob'
                                className={classes.radioHelperText}
                              >
                                <span>
                                  <ADGMImage
                                    name='ADGMwallet.svg'
                                    alt='ADGMwallet'
                                  />{' '}
                                  <FormattedMessage {...messages.dari_wallet} />
                                </span>
                                {typeof balance === 'number' ? (
                                  <span className={classes.textADGMGray}>
                                    <FormattedMessage {...messages.balance} />:{' '}
                                    <FormattedMessage
                                      {...messages.AED_amount}
                                      values={{
                                        num: formatCurrencyWithoutCurrency(
                                          balance
                                        ),
                                      }}
                                    />
                                  </span>
                                ) : null}
                              </label>
                            </RadioGroup>
                          )}
                        </FormControl>
                      </div>
                    </div>
                  </div>
                </Paper>
                <Paper variant='outlined' className={classes.paperCardFrame}>
                  <div className={classes.titleHead}>
                    <Typography
                      variant='h6'
                      component='h2'
                      className={classes.Title}
                    >
                      <FormattedMessage {...messages.payment_detail} />
                    </Typography>
                  </div>
                  <div className={classes.innerCardGrid}>
                    {isLease ? (
                      <>
                        {fees?.paymentGeneralDetailList
                          ?.filter(
                            (fee) => fee.paymentType !== 'DARI_SERVICE_FEE'
                          )
                          .map((item) => {
                            if (Number(item?.amount) === 0) {
                              return '';
                            }
                            return (
                              <Box
                                display='flex'
                                justifyContent='space-between'
                                className={classes.paymentHead}
                                mb={3}
                              >
                                {keyEmptyCheck(
                                  item?.name?.replaceAll(' ', '_')
                                )}
                                <span className={classes.textright}>
                                  <FormattedMessage {...messages.currency} />{' '}
                                  {item?.amount}
                                </span>
                              </Box>
                            );
                          })}
                        {!(!fees?.vatCharges && !DARI_SERVICE_FEE) && (
                          <Box
                            display='flex'
                            justifyContent='space-between'
                            mb={1}
                            className={classes.paymentHead}
                          >
                            {keyEmptyCheck('OTHERS')}
                            <span className={classes.textright}>
                              <FormattedMessage {...messages.currency} />{' '}
                              {fees?.vatCharges + DARI_SERVICE_FEE}
                            </span>
                          </Box>
                        )}
                        {DARI_SERVICE_FEE && (
                          <Box
                            display='flex'
                            justifyContent='space-between'
                            mb={1}
                            className={classes.paymentDetails}
                          >
                            <FormattedMessage {...messages.DARI_SERVICE_FEE} />
                            <span className={classes.textright}>
                              <FormattedMessage {...messages.currency} />{' '}
                              {DARI_SERVICE_FEE}
                            </span>
                          </Box>
                        )}
                        {fees?.vatCharges && Number(fees?.vatCharges) > 0 && (
                          <Box
                            display='flex'
                            justifyContent='space-between'
                            mb={1}
                            className={classes.paymentDetails}
                          >
                            <FormattedMessage {...messages.vat_charges} />
                            <span className={classes.textright}>
                              <FormattedMessage {...messages.currency} />{' '}
                              {fees?.vatCharges}
                            </span>
                          </Box>
                        )}
                      </>
                    ) : (
                      <>
                        {fees?.paymentGeneralDetailList?.map((item) => {
                          if (Number(item?.amount) === 0) {
                            return '';
                          }
                          return (
                            <div className={classes.paymentDiscription}>
                              {keyEmptyCheck(item?.name?.replaceAll(' ', '_'))}
                              <span className={classes.textright}>
                                <FormattedMessage {...messages.currency} />{' '}
                                {item?.amount}
                              </span>
                            </div>
                          );
                        })}
                      </>
                    )}

                    {fees?.dariAmount && Number(fees?.dariAmount) > 0 ? (
                      <div className={classes.paymentDiscription}>
                        <FormattedMessage {...messages.dari_payment} />
                        <span className={classes.textright}>
                          <FormattedMessage {...messages.currency} />{' '}
                          {fees?.dariAmount}
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                    {fees?.dmtAmount &&
                    Number(fees?.dmtAmount) > 0 &&
                    isSale !== true ? (
                      <div className={classes.paymentDiscription}>
                        <FormattedMessage {...messages.Dmt_Service_Fee} />
                        <span className={classes.textright}>
                          <FormattedMessage {...messages.currency} />{' '}
                          {fees?.dmtAmount}
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                    {!isLease &&
                    fees?.vatCharges &&
                    Number(fees?.vatCharges) > 0 ? (
                      <div className={classes.paymentDiscription}>
                        <FormattedMessage {...messages.vat_charges} />
                        <span className={classes.textright}>
                          {' '}
                          <FormattedMessage {...messages.currency} />{' '}
                          {fees?.vatCharges}
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                    <div
                      className={classNames(
                        classes.paymentDiscription,
                        classes.totalpayment
                      )}
                    >
                      <FormattedMessage {...messages.total_to_be_paid} />
                      <span className={classes.textright}>
                        {' '}
                        <FormattedMessage {...messages.currency} />{' '}
                        {fees?.totalAmount}
                      </span>
                    </div>
                    <div className={classes.fixedbtnHolder}>
                      <Button
                        variant='contained'
                        className={classes.PaynowBtn}
                        onClick={payNowHanlder}
                      >
                        <FormattedMessage {...messages.pay_now} />
                      </Button>
                    </div>
                  </div>
                </Paper>
                {fees?.dmtAmount &&
                  Number(fees?.dmtAmount) > 0 &&
                  isSale === true && (
                    <Paper
                      variant='outlined'
                      className={classes.paperCardFrame}
                    >
                      <div className={classes.titleHead}>
                        <Typography
                          variant='h6'
                          component='h2'
                          className={classes.Title}
                        >
                          <FormattedMessage {...messages.on_site_fees} />
                        </Typography>
                      </div>
                      <div className={classes.innerCardGrid}>
                        <div className={classes.paymentDiscription}>
                          <FormattedMessage {...messages.sale_agreement_fee} />
                          <span className={classes.textright}>
                            <FormattedMessage {...messages.currency} />{' '}
                            {fees?.dmtAmount}
                          </span>
                        </div>
                        <div className={classes.infoMessageTooltip}>
                          <ADGMImage
                            name='Information.svg'
                            alt='InformationImg'
                          />
                          <FormattedMessage
                            {...messages.sale_agreement_fee_dmt}
                          />
                        </div>
                      </div>
                    </Paper>
                  )}
              </Hidden>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper variant='outlined' className={classes.paperCardFrame}>
                <div className={classes.titleHead}>
                  <Typography
                    variant='h6'
                    component='h2'
                    className={classes.Title}
                  >
                    <FormattedMessage {...messages.pay_with} />
                  </Typography>
                </div>
                <div className={classes.innerCardGrid}>
                  {lowBalance ? (
                    <div className={classes.adgmwalletDetail}>
                      <div className={classes.warningmassage}>
                        <ADGMImage
                          name='Information.svg'
                          alt='InformationIcon'
                        />
                        <Typography variant='body1'>
                          <FormattedMessage
                            {...messages.wallet_empty_message}
                          />
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  <div className={classes.debitcardDetail}>
                    <div className={classes.radioactiveHolder}>
                      <FormControl
                        component='fieldset'
                        className={classes.fieldsetradio}
                      >
                        <RadioGroup className={classes.usercheckedradio}>
                          <Radio
                            value='card'
                            name='radio-button-demo'
                            inputProps={{ 'aria-label': 'A' }}
                            id='userRadioA'
                            checked={cardActive}
                            onClick={creditCardHandler}
                          />
                          <label
                            htmlFor='userRadioA'
                            className={classes.radioHelperText}
                          >
                            <span>
                              <FormattedMessage
                                {...messages.debit_credit_card}
                              />
                            </span>
                          </label>
                        </RadioGroup>
                        <RadioGroup
                          className={classNames(
                            classes.usercheckedradio,
                            classes.usercheckedradioColumn
                          )}
                        >
                          <Radio
                            value='wallet'
                            name='radio-button-demo'
                            inputProps={{ 'aria-label': 'b' }}
                            id='userRadiob'
                            checked={walletActive}
                            onClick={walletHandler}
                            disabled={disableWalletOption}
                          />
                          <label
                            htmlFor='userRadiob'
                            className={classes.radioHelperTextColumn}
                          >
                            <span>
                              <ADGMImage
                                name='ADGMwallet.svg'
                                alt='ADGMwallet'
                              />{' '}
                              <FormattedMessage {...messages.dari_wallet} />
                            </span>
                            {typeof balance === 'number' ? (
                              <span className={classes.textADGMGray}>
                                <FormattedMessage {...messages.balance} />:{' '}
                                <FormattedMessage
                                  {...messages.AED_amount}
                                  values={{
                                    num: formatCurrencyWithoutCurrency(balance),
                                  }}
                                />
                              </span>
                            ) : null}
                          </label>
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </Paper>
              <Paper variant='outlined' className={classes.paperCardFrame}>
                <div className={classes.titleHead}>
                  <Typography
                    variant='h6'
                    component='h2'
                    className={classes.Title}
                  >
                    <FormattedMessage {...messages.payment_details} />
                  </Typography>
                </div>

                <div className={classes.innerCardGrid}>
                  {isLease ? (
                    <>
                      {fees?.paymentGeneralDetailList
                        ?.filter(
                          (fee) => fee.paymentType !== 'DARI_SERVICE_FEE'
                        )
                        .map((item) => {
                          if (Number(item?.amount) === 0) {
                            return '';
                          }
                          return (
                            <Box
                              display='flex'
                              justifyContent='space-between'
                              className={classes.paymentHead}
                              mb={3}
                            >
                              {keyEmptyCheck(item?.name?.replaceAll(' ', '_'))}
                              <span className={classes.textright}>
                                <FormattedMessage {...messages.currency} />{' '}
                                {item?.amount}
                              </span>
                            </Box>
                          );
                        })}
                      {!(!fees?.vatCharges && !DARI_SERVICE_FEE) && (
                        <Box
                          display='flex'
                          justifyContent='space-between'
                          mb={1}
                          className={classes.paymentHead}
                        >
                          {keyEmptyCheck('OTHERS')}
                          <span className={classes.textright}>
                            <FormattedMessage {...messages.currency} />{' '}
                            {fees?.vatCharges + DARI_SERVICE_FEE}
                          </span>
                        </Box>
                      )}
                      {DARI_SERVICE_FEE && (
                        <Box
                          display='flex'
                          justifyContent='space-between'
                          mb={1}
                          className={classes.paymentDetails}
                        >
                          <FormattedMessage {...messages.DARI_SERVICE_FEE} />
                          <span className={classes.textright}>
                            <FormattedMessage {...messages.currency} />{' '}
                            {DARI_SERVICE_FEE}
                          </span>
                        </Box>
                      )}
                      {fees?.vatCharges && Number(fees?.vatCharges) > 0 && (
                        <Box
                          display='flex'
                          justifyContent='space-between'
                          mb={1}
                          className={classes.paymentDetails}
                        >
                          <FormattedMessage {...messages.vat_charges} />
                          <span className={classes.textright}>
                            <FormattedMessage {...messages.currency} />{' '}
                            {fees?.vatCharges}
                          </span>
                        </Box>
                      )}
                    </>
                  ) : (
                    fees?.paymentGeneralDetailList?.map((item) => {
                      if (Number(item?.amount) === 0) {
                        return '';
                      }
                      return (
                        <div className={classes.paymentDiscription}>
                          {keyEmptyCheck(item?.name?.replaceAll(' ', '_'))}
                          <span className={classes.textright}>
                            <FormattedMessage {...messages.currency} />{' '}
                            {item?.amount}
                          </span>
                        </div>
                      );
                    })
                  )}

                  {fees?.dariAmount && Number(fees?.dariAmount) > 0 ? (
                    <div className={classes.paymentDiscription}>
                      <FormattedMessage {...messages.dari_payment} />
                      <span className={classes.textright}>
                        <FormattedMessage {...messages.currency} />{' '}
                        {fees?.dariAmount}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  {fees?.dmtAmount &&
                  Number(fees?.dmtAmount) > 0 &&
                  isSale !== true ? (
                    <div className={classes.paymentDiscription}>
                      <FormattedMessage {...messages.Dmt_Service_Fee} />
                      <span className={classes.textright}>
                        <FormattedMessage {...messages.currency} />{' '}
                        {fees?.dmtAmount}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  {!isLease &&
                  fees?.vatCharges &&
                  Number(fees?.vatCharges) > 0 ? (
                    <div className={classes.paymentDiscription}>
                      <FormattedMessage {...messages.vat_charges} />
                      <span className={classes.textright}>
                        <FormattedMessage {...messages.currency} />{' '}
                        {fees?.vatCharges}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  <div
                    className={classNames(
                      classes.paymentDiscription,
                      classes.totalpayment
                    )}
                  >
                    <FormattedMessage {...messages.total_to_be_paid} />
                    <span className={classes.textright}>
                      <FormattedMessage {...messages.currency} />{' '}
                      {fees?.totalAmount}
                    </span>
                  </div>

                  <Button
                    variant='contained'
                    className={classes.PaynowBtn}
                    onClick={payNowHanlder}
                  >
                    <FormattedMessage {...messages.pay_now} />
                  </Button>
                </div>
              </Paper>
              {fees?.dmtAmount &&
                Number(fees?.dmtAmount) > 0 &&
                isSale === true && (
                  <Paper variant='outlined' className={classes.paperCardFrame}>
                    <div className={classes.titleHead}>
                      <Typography
                        variant='h6'
                        component='h2'
                        className={classes.Title}
                      >
                        <FormattedMessage {...messages.on_site_fees} />
                      </Typography>
                    </div>
                    <div className={classes.innerCardGrid}>
                      <div className={classes.paymentDiscription}>
                        <FormattedMessage {...messages.sale_agreement_fee} />
                        <span className={classes.textright}>
                          <FormattedMessage {...messages.currency} />{' '}
                          {fees?.dmtAmount}
                        </span>
                      </div>
                      <div className={classes.infoMessageTooltip}>
                        <ADGMImage
                          name='Information.svg'
                          alt='InformationImg'
                        />
                        <FormattedMessage
                          {...messages.sale_agreement_fee_dmt}
                        />
                      </div>
                    </div>
                  </Paper>
                )}
              <Button
                variant='text'
                className={classNames(classes.rejectApplicationbtn)}
                onClick={toggleModalApplicationReject}
              >
                <ADGMImage
                  name='cancel_payment.svg'
                  alt='trash'
                  onClick={toggleModalApplicationReject}
                  aria-hidden
                />
                <FormattedMessage {...messages.cancel_application} />
              </Button>
            </Grid>
          </Grid>
        )}
        <CancelApplicationModal
          open={isModalOpenApplicationReject}
          onClose={() => setModalOpenApplicationReject(false)}
          cancelApplication={submitApplicationCancel}
        />
      </Container>
    </div>
  );
}

Payment.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  breadCrumbs: PropTypes.array.isRequired,
  applicationId: PropTypes.string,
  balance: PropTypes.string.isRequired,
  fees: PropTypes.object.isRequired,
  isSale: PropTypes.bool.isRequired,
  submitApplicationCancel: PropTypes.func.isRequired,
  paymentHanlder: PropTypes.func.isRequired,
  isLease: PropTypes.bool,
  walletFailure: PropTypes.object,
};

Payment.defaultProps = {
  isLease: false,
  walletFailure: null,
  applicationId: '',
};
export default withStyles(styles)(Payment);
